import { Record as ImRecord, type RecordOf } from 'immutable';

import type { QcsSyncResourceStore } from 'app-components/flux/core/resourceStoreTypes';

export const TAXES_REDUCER_KEY = 'taxesStore';
export const TAXES_VERSION = 1;

// TODO: define once API is ready
export type FilingStatus = 'SINGLE' | 'MARRIED_FILING_JOINTLY' | 'MARRIED_FILING_SEPARATELY' | 'HEAD_OF_HOUSEHOLD';
export type TaxInputProps = {
  year?: number;
  filingStatus?: FilingStatus;
  wages?: number;
  // TODO: more
};
export type TaxInput = RecordOf<TaxInputProps>;
export const mkTaxInput = ImRecord<TaxInputProps>({
  filingStatus: undefined,
  year: undefined,
  wages: undefined,
});

export type TaxOutputProps = {
  taxPaymentsCalc: {
    totalEstimatedTaxPaymentsAndRefundsApplied: number;
    estimatedTaxesPaidOrPlanned: number;
  };
  // TODO: more
};
export type TaxOutput = RecordOf<TaxOutputProps>;
export const mkTaxOutput = ImRecord<TaxOutputProps>({
  taxPaymentsCalc: {
    totalEstimatedTaxPaymentsAndRefundsApplied: 0,
    estimatedTaxesPaidOrPlanned: 0,
  },
});

export type TaxProps = {
  id?: string;
  isDeleted?: boolean;
  clientId?: string;
  createdAt?: string;
  input: TaxInput | TaxInputProps;
  output?: TaxOutput | TaxOutputProps;
};
export type Tax = RecordOf<TaxProps>;
export const TaxRecord = ImRecord<TaxProps>({
  id: undefined,
  isDeleted: undefined,
  clientId: undefined,
  createdAt: undefined,
  input: mkTaxInput(),
  output: mkTaxOutput(),
});
export const mkTax = (props: TaxProps): Tax =>
  TaxRecord({
    ...props,
    input: mkTaxInput(props.input),
    output: mkTaxOutput(props.output),
  });

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [TAXES_REDUCER_KEY]: QcsSyncResourceStore<TaxProps>;
  }
}
